<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'empty') {
    <empty-layout></empty-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Panel klienta VAZUVI -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'vazuvi') {
    <vazuvi-layout></vazuvi-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Panel administratora -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Classy -->
@if (layout === 'classy') {
    <classy-layout></classy-layout>
}
